/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Group_RecentInputs */

const en_us2_search_group_recent = /** @type {(inputs: Search_Group_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent searches`)
};

const pt_br2_search_group_recent = /** @type {(inputs: Search_Group_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscas recentes`)
};

const es_419_search_group_recent = /** @type {(inputs: Search_Group_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsquedas recientes`)
};

const pt_pt2_search_group_recent = /** @type {(inputs: Search_Group_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisas recentes`)
};

const fr_fr2_search_group_recent = /** @type {(inputs: Search_Group_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherches récentes`)
};

const de_de2_search_group_recent = /** @type {(inputs: Search_Group_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Suchen`)
};

const it_it2_search_group_recent = /** @type {(inputs: Search_Group_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerche recenti`)
};

/**
* | output |
* | --- |
* | "Recent searches" |
*
* @param {Search_Group_RecentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_group_recent = /** @type {((inputs?: Search_Group_RecentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Group_RecentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_group_recent(inputs)
	if (locale === "es-419") return es_419_search_group_recent(inputs)
	if (locale === "pt-PT") return pt_pt2_search_group_recent(inputs)
	if (locale === "fr-FR") return fr_fr2_search_group_recent(inputs)
	if (locale === "de-DE") return de_de2_search_group_recent(inputs)
	if (locale === "it-IT") return it_it2_search_group_recent(inputs)
	return en_us2_search_group_recent(inputs)
});
export { search_group_recent as "search.group_recent" }